export enum ItemStatus {
  ORDERING_DISABLED = 'ORDERING_DISABLED',
  DAYPART_UNAVAILABLE = 'DAYPART_UNAVAILABLE',
  CHECK_STORE_AVAILABILITY = 'CHECK_STORE_AVAILABILITY',
  AVAILABLE_IN_STORE = 'AVAILABLE_IN_STORE',
  MAX_CART_QUANTITY_MET = 'MAX_CART_QUANTITY_MET',
}
